export default __webpack_public_path__ + "asset/img/taoke-flag-1~1e3b499d.png";